import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import merge from 'lodash/merge';
import { keyBy } from "lodash";

import Graph_QL, { DynamicDataObk } from "../..";
import { FeedCurveSettings } from "../GQLCalls/getFeedCurveSettingsCall";


export type FeedCurveSettingsItem = DynamicDataObk<FeedCurveSettings[]>

const feedCurveSettingsDataAdapter = createEntityAdapter({
  selectId: (item: FeedCurveSettingsItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<FeedCurveSettingsItem, string>, {con, data}: FeedCurveSettingsItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    if (data.length === 0) {return}
    const mergedData = Object.values(merge(keyBy(state.entities[identifier].data, (data) => (`${data.feedcurve_id}-${data.id}`)), keyBy(data, (data) => (`${data.feedcurve_id}-${data.id}`))));
    const newPayload = {con, data: mergedData}
    feedCurveSettingsDataAdapter.upsertOne(state, newPayload);
  } else { feedCurveSettingsDataAdapter.addOne(state, {con, data})}
}

const feedCurveSettingSlice = createSlice({
  name: "feedCurveSettings",
    initialState: feedCurveSettingsDataAdapter.getInitialState<FeedCurveSettingsItem[]>([]),
      reducers: {
        maintained: (state, {payload}:PayloadAction<FeedCurveSettingsItem>) => {
          mergePayloadAndState(state, payload);
        },
        add: (state, {payload}:PayloadAction<FeedCurveSettingsItem>) => {
          mergePayloadAndState(state, payload);
        },
    }
})

export const FeedCurveSettingsActions = feedCurveSettingSlice.actions;
export default feedCurveSettingSlice.reducer;